import {
  toast,
  ToastContainer,
  Slide,
  Zoom,
  Flip,
  Bounce,
} from "react-toastify";

export default function ToastNotification(props) {
  const {
    type,
    message,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    draggable,
    progress,
    position,
    transition,
  } = props;

  const defaultType = "error";
  const defaultMessage = "message attribute is not passed or null";
  const defaultPosition = "bottom-center";
  const defaultAutoClose = 5000;
  const defaultHideProgressBar = true;
  const defaultCloseOnClick = true;
  const defaultPauseOnHover = true;
  const defaultDraggable = true;
  const defaultProgress = 0.1;
  const defaultTransition = Slide;

  return toast[type ?? defaultType](message ?? defaultMessage, {
    position: position ?? defaultPosition,
    autoClose: autoClose ?? defaultAutoClose,
    hideProgressBar: hideProgressBar ?? defaultHideProgressBar,
    closeOnClick: closeOnClick ?? defaultCloseOnClick,
    pauseOnHover: pauseOnHover ?? defaultPauseOnHover,
    draggable: draggable ?? defaultDraggable,
    progress: progress ?? defaultProgress,
    transition: transition ?? defaultTransition,

    theme: "colored",
  });
}
